import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as Core from '../../core';
import { useProfile } from '../../hooks/store';
import { AuthenticationService } from '../../services/authenticationService';

import './index.scss';

const ImpersonationBanner = (): JSX.Element | null => {
    const profile = useProfile();
    const hasStashedToken = AuthenticationService.hasStashedToken();
    const adminName = AuthenticationService.getStashedAccountName();

    const returnToAdmin = useCallback(() => {
        if (!AuthenticationService.hasStashedToken()) return;

        AuthenticationService.restoreToken();
        window.location.reload();
    }, []);

    if (!hasStashedToken) return null;

    const viewingAs = profile ? Core.Identity.renderMemberName(profile) : undefined;
    const message = viewingAs ? `You are impersonating ${viewingAs}` : 'You are impersonating another account';
    const buttonLabel = adminName ? `Back to ${adminName}` : 'Back to your admin account';

    return (
        <div className="impersonation-banner" role="status">
            <span>{message}</span>
            <button type="button" className="impersonation-banner-button" onClick={returnToAdmin}>
                <FontAwesomeIcon icon={['fas', 'arrow-left']} />
                {buttonLabel}
            </button>
        </div>
    );
};

export default ImpersonationBanner;
